import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Countdown = styled(Typography)(({ theme }) => ({
	marginTop: theme.spacing(1),
	color: theme.palette.primary.contrastText,
	fontVariantNumeric: 'tabular-nums',
}));

export const PendingText = styled(Typography)(({ theme }) => ({
	marginTop: theme.spacing(1),
	padding: theme.spacing(0, 2),
	color: theme.palette.primary.contrastText,
	textAlign: 'center',
}));
